/*
 * File: version-check.service.ts
 * Project: rast-app
 * Create Date: Wednesday, 1st April 2026
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Wednesday, 1st April 2026 3:54:59 pm
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2026 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { RemoteConfigService } from '../remote-config/remote-config.service';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.vonbraun.rast';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {

  constructor(
    private readonly alertCtrl: AlertController,
    private readonly remoteConfigService: RemoteConfigService
  ) {}

  async checkMinimumVersion(): Promise<void> {
    try {
      await this.remoteConfigService.fetchAndActivate();
      const minimumVersion = await this.remoteConfigService.getMinimumVersion();
      const { version } = await App.getInfo();

      if (this.isVersionOutdated(version, minimumVersion)) {
        await this.showForceUpdateAlert();
      }
    } catch {
    }
  }

  private isVersionOutdated(current: string, minimum: string): boolean {
    const cur = current.split('.').map(Number);
    const min = minimum.split('.').map(Number);

    for (let i = 0; i < 3; i++) {
      if ((cur[i] ?? 0) < (min[i] ?? 0)) return true;
      if ((cur[i] ?? 0) > (min[i] ?? 0)) return false;
    }
    return false;
  }

  private async showForceUpdateAlert(): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Atualização necessária',
      message: 'Uma nova versão do app está disponível. Atualize para continuar usando o aplicativo.',
      backdropDismiss: false,
      cssClass: 'add-part-confirmation-alert',

      buttons: [
        {
          text: 'Atualizar',
          cssClass: 'alert-button-confirm',
          handler: () => {
            Browser.open({ url: PLAY_STORE_URL });
            return false;
          }
        }
      ]
    });

    await alert.present();
  }
}
